import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { WhatWeDo } from './components/WhatWeDo';
import { Thesis } from './components/Thesis';
import { Companies } from './components/Companies';
import { About } from './components/About';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import DeliverablesAndSignal from './components/sections/DeliverablesAndSignal';
import OperatorsLens from './components/sections/OperatorsLens';

function App() {
  return (
    <div className="min-h-screen bg-c-dark">
      <Navbar />
      <main>
        <Hero />
        <WhatWeDo />
        <Thesis />
        <Companies />
        <About headshot="/lee-headshot-1.jpg" />
        <Contact />
        <DeliverablesAndSignal />
        <OperatorsLens />
      </main>
      <Footer />
    </div>
  );
}

export default App;
